/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Storage_Bar_AddonInputs */



/**
* | output |
* | --- |
* | "Add-on ({size})" |
*
* @param {Storage_Bar_AddonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const storage_bar_addon = /** @type {((inputs: Storage_Bar_AddonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storage_Bar_AddonInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Zusatz (${i?.size})`)
	return /** @type {LocalizedString} */ (`Add-on (${i?.size})`)
});